export const EVENT_BOOKING_RESCHEDULE_ENDPOINT = '/account/ChangeSchedule';
